class DeployerCollectionFilter extends DeployerElement {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  setupVariables() {
    this.filterData = [];
    this.form = this.querySelector("form");
    this.deployerPackBuilder = document.querySelector("deployer-pack-builder");
    this.productGrid = document.getElementById("product-grid");
  }

  setupEvents() {
    this.form.addEventListener("input", this.onSubmitHandler.bind(this));
    document.addEventListener("main-collection-filter:toggle-active-facets", this.toggleActiveFacets.bind(this));
  }

  onSubmitHandler(event) {
    if (event.target.hasAttribute("data-simulated")) {
      return;
    }
    event.preventDefault();
    console.log("clicked");
    this.renderPage(event.target.name, event.target.dataset.value);
  }

  renderPage(searchParamName, searchParamValue, updateURLHash = true) {
    const sections = this.sectionsToRender;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(searchParamName, searchParamValue);

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      this.filterData.some(filterDataUrl) ? this.renderContentsFromCache(filterDataUrl) : this.renderContentsFromFetch(url);
    });

    if (updateURLHash === true) this.updateURLHash(searchParamName, searchParamValue);
  }

  toggleActiveFacets() {
    const urlParams = new URLSearchParams(window.location.search);

    this.querySelectorAll("deployer-facets").forEach((facet) => {
      const input = facet.querySelector("input");
      const paramName = input.name;
      const paramValue = input.value;

      if (urlParams.get(paramName) === paramValue) {
        facet.setAttribute("data-active", true);
        input.checked = true;
      } else {
        facet.removeAttribute("data-active");
        input.checked = false;
      }
    });
  }

  renderContentsFromFetch(url) {
    fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = response;
        this.filterData = [...this.filterData, { html, url }];
        this.renderContents(html);
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
      });
  }

  renderContentsFromCache(filterDataUrl) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderContents(html);
  }

  renderContents(html) {
    this.sectionsToRender.forEach((section) => {
      document.querySelector(section.id).innerHTML = this.getSectionInnerHTML(html, section.id);
    });
  }

  updateURLHash(paramName = "", paramValue = "") {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    if (paramName === "") {
      url.search = "";
    } else if (paramValue === "") {
      searchParams.delete(paramName);
    } else {
      searchParams.set(paramName, paramValue);
    }

    url.search = `?${searchParams.toString()}`;
    history.replaceState({ searchParams: searchParams.toString() }, "", url);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  removeActiveFacets() {
    const allFacets = this.querySelectorAll("deployer-facets");
    allFacets.forEach((facet) => {
      facet.removeAttribute("data-active");

      const input = facet.querySelector("input");
      if (!input) return;
      input.checked = false;
      this.updateURLHash(input.name, "");
    });
  }

  get sectionsToRender() {
    return [
      {
        id: "#product-grid",
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }
}

if (!customElements.get("deployer-collection-filter-form")) {
  window.customElements.define("deployer-collection-filter-form", DeployerCollectionFilter);
}

class DeployerFacets extends DeployerElement {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    // Vérifie si aucun autre filtre n'est actif avant d'appeler setDefaultActive
    const hasActiveFilter = document.querySelector("deployer-facets[data-active='true']");

    if (!hasActiveFilter) {
      this.setDefaultActive();
    }
  }

  setupVariables() {
    this.deployerFilterForm = this.closest("deployer-collection-filter-form");
    this.input = this.querySelector("input");
  }

  setupEvents() {
    this.input.addEventListener("click", this.selectedFilter.bind(this));
  }

  setDefaultActive() {
    this.dataset.default == "true" ? this.selectedFilter(this.input.dispatchEvent(new Event("click", { bubbles: true }))) : null;
  }

  selectedFilter(event) {
    this.deployerFilterForm.removeActiveFacets();
    this.setActive();

    this.deployerFilterForm.updateURLHash(this.input.name, this.input.dataset.value);

    this.input.setAttribute("data-simulated", "true");
    this.input.dispatchEvent(new Event("input", { bubbles: true }));
    this.input.removeAttribute("data-simulated");
  }

  setActive() {
    this.input.checked = true;
    this.setAttribute("data-active", true);
  }

  setInactive() {
    this.input.checked = false;
    this.removeAttribute("data-active");
  }
}

if (!customElements.get("deployer-facets")) {
  window.customElements.define("deployer-facets", DeployerFacets);
}
